import {
  CreateTaskCommentReactionDocument,
  DeleteTaskCommentReactionDocument,
} from 'generated/resources/graphql'

import { ReactionsReactionValues } from 'modules/core/components/Reactions/Reaction'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useTaskCommentReactions = () => {
  const [addReaction] = useMutation(CreateTaskCommentReactionDocument, {
    extractorFn: (data) => data.tasksMutations.createTaskCommentReactionTasksTask,
  })

  const [deleteReaction] = useMutation(DeleteTaskCommentReactionDocument, {
    extractorFn: (data) => data.tasksMutations.deleteTaskCommentReactionTasksTask,
  })

  const handleAddReaction = async (
    variables: ReactionsReactionValues,
    parentResourceId: number
  ) => {
    const unhandledResult = await addReaction({
      variables: {
        authorId: variables.authorId,
        companyId: variables.companyId,
        textCode: variables.textCode,
        taskId: parentResourceId,
        commentId: variables.resourceId,
      },
    })

    const result = handleResult(unhandledResult, () => undefined)

    if (!result.success) {
      return
    }

    track(trackingEvents.tasks.taskCommentReactionAdded, {
      reaction_type: variables.textCode,
      taskId: parentResourceId,
      commentId: variables.resourceId,
    })

    app.setFlash({
      type: 'correct',
      message: i18n.t('common.saved_successfully'),
    })

    return {
      id: Number(result.data.task?.comments[0]?.reactions[0]?.id),
    }
  }

  const handleDeleteReaction = async (
    id: number,
    commentId: number,
    parentResourceId: number,
    textCode: string
  ) => {
    const unhandledResult = await deleteReaction({
      variables: {
        id: id,
      },
    })

    const result = handleResult(unhandledResult, () => undefined)

    if (!result.success) {
      return
    }

    track(trackingEvents.tasks.taskCommentReactionRemoved, {
      reaction_type: textCode,
      taskId: parentResourceId,
      commentId,
    })

    app.setFlash({
      type: 'correct',
      message: i18n.t('common.saved_successfully'),
    })

    return {
      success: true,
    }
  }

  return {
    addReaction: handleAddReaction,
    deleteReaction: handleDeleteReaction,
  }
}
